/** biome-ignore-all lint/suspicious/noExplicitAny: Allowing any for flexibility as HTTP request could be anything */
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { catchError, Observable, of } from 'rxjs';

export class NewRelicInterceptor implements HttpInterceptor {
  constructor() {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    return next.handle(req).pipe(
      catchError((error) => {
        try {
          (window as any).newrelic.noticeError(error);
        } catch (e) {
          console.info('Error sending log to newrelic', e);
        }

        return of(error);
      })
    );
  }
}
